// imports
import CTAccordion from './CTAccordion';

// private statics

// class definition
export default class FaqAccordion extends CTAccordion {
    // constructor
    constructor (args = {}, objectName = 'accordion') {
        args.debug = args.debug || false;

        args.group = 'faq-accordion';

        // super
        super(args, objectName);
    }

    // methods
    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
